// Mattress Reviews & Comparisons modal
import React from "react";
import PropTypes from "prop-types";

const StepProgressBar = ({ currentIdx, steps }) => {
    return (
        <div className="step-progress-bar mt-4">
            <ul>
                {steps.map((step, idx) => {
                    const isActive = currentIdx === idx + 1;
                    const isDone =
                        idx <= currentIdx - 1 && currentIdx !== idx + 1;

                    return (
                        <li
                            key={`step-progress-item${idx}`}
                            className={`step-progress-item ${
                                isActive ? "active" : ""
                            } ${isDone ? "done" : ""}`}
                        >
                            <div className="step-title">
                                <span className="text-clip">{step}</span>
                            </div>
                            <div className="step-bar"></div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

StepProgressBar.defaultProps = {
    currentIdx: 1,
};

StepProgressBar.propTypes = {
    currentIdx: PropTypes.number,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default StepProgressBar;
